import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35a84d47")

_pushScopeId("data-v-35a84d47")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Apple Pay")
const _hoisted_2 = {
  key: 1,
  class: "spin"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toolbar = _resolveComponent("toolbar")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_radio = _resolveComponent("ion-radio")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.$tr(_ctx.trMenu, 'payMethods'),
        backbutton: true
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withId(() => [
          (_ctx.loaded)
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_radio_group, {
                    modelValue: _ctx.defaultMethod,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.defaultMethod = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            color: "dark",
                            icon: _ctx.logoApple
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_text, null, {
                            default: _withId(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_radio, {
                            value: "apple",
                            slot: "end"
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payMethods, (payMethod, key) => {
                        return (_openBlock(), _createBlock(_component_ion_item, { key: key }, {
                          default: _withId(() => [
                            (payMethod.cardBrand === 'MasterCard')
                              ? (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 0,
                                  slot: "start",
                                  src: "/assets/icon/mastercard.svg"
                                }))
                              : (payMethod.cardBrand === 'Visa')
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 1,
                                    slot: "start",
                                    src: "/assets/icon/visa.svg"
                                  }))
                                : (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 2,
                                    slot: "start",
                                    icon: _ctx.card
                                  }, null, 8, ["icon"])),
                            _createVNode(_component_ion_text, null, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(payMethod.cardLastFour), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_radio, {
                              value: payMethod.id,
                              slot: "end"
                            }, null, 8, ["value"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, { name: "circles" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})